import { FC } from "react";

import { MapRouteBlockTypeEnum } from "@ryde/shared";

import { KanbanMap } from "../common";
import { KanbanMapStyled } from "./rides.kanban.styled";
import { IGridCell } from "./rides.kanban.wrapper";

export const RidesKanbanMap: FC<IGridCell> = ({ $gridArea: gridArea }) => {
  return (
    <KanbanMapStyled $gridArea={gridArea}>
      <div className="map_scrollable_content">
        <KanbanMap routeBlockType={MapRouteBlockTypeEnum.Kanban} />
      </div>
    </KanbanMapStyled>
  );
};
